<template lang="pug">
.sendmessage-modal
  b-modal(ref="modal" size="xl" no-close-on-backdrop no-close-on-esc hide-footer)
    template(#modal-header="{ cancel }")
      .sendmessage-modal-header
        span.float-left.title {{ title }}
        .float-right
          button.btn.index-btn(v-for="(fileUrl, index) in files" type="button" :class="isSelected(index)" @click="selectImage(index)") {{ index + 1 }}
      button(type="button" class="close" @click="cancel()") ×
    .sendmessage-modal-body
      div(v-if="0 < files.length && files[selected]")
        div(v-show="files[selected].type == 'image/jpeg' || files[selected].type == 'image/png'")
          img(:src="fileUrl")
        div(v-show="files[selected].type == 'video/mp4'")
          video(playsinline autoplay muted loop ref="videomp4" v-show="canPlay" :src="fileUrl" type="video/mp4" controls)
        div(v-show="files[selected].type == 'video/quicktime'")
          video(playsinline autoplay muted loop ref="videomov" v-show="canPlay" :src="fileUrl" type="video/quicktime" controls)
        // v-ifにしないとdataの書き換えが行われないのでv-ifを使用する
        div(v-if="files[selected].type == 'application/pdf'")
          object.pdf(:data="fileUrl" type="application/pdf")
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import FileReaderWrapper from "@/commons/utils/FileReaderWrapper";

@Component
export default class QuestionnaireFilePreviewModal extends Vue {
  /**
   * タイトル
   * このコンポーネントは画面専用で汎用的に作る必要がないため、
   * 画面表示内容は表示時に渡す
   */
  title: string = "";
  /** ファイル */
  files: Array<File> = [];
  /** 選択しているファイルのindex */
  selected: number = 0;
  /** 表示対象ファイルのURL */
  fileUrl: string = "";
  /** 再生可能か */
  canPlay: boolean = false;

  /**
   * 画像表示ボタンのスタイルを返す
   *
   * 選択している画像のインデックスと比較して、選択している画像であれば強調表示用のスタイルを返す
   *
   * @params index ボタンのインデックス
   */
  public isSelected(index: number): string {
    if (this.selected == index) {
      return "selected";
    } else {
      return "";
    }
  }

  /**
   * モーダル表示
   *
   * このコンポーネントは表示・非表示を繰り返すので、表示するタイミングで全体的な初期化処理を行う
   * 同じ理由で、モーダルのタイトルと表示内容も表示時に渡す
   *
   * @param title モーダルタイトル
   * @param careimage モーダル表示する介護記録
   */
  public async show(title: string, canDelete: boolean, files: Array<File>) {
    // 初期化
    this.title = title;
    this.files = files;

    // 初期化した後、各要素が作られるまで待ってから読込む
    Vue.nextTick(async () => {
      // 画面表示対象を初期化
      this.selected = 0;

      if (this.files && this.files[this.selected]) {
        if (this.files[this.selected].type == "image/jpeg" || this.files[this.selected].type == "image/png") {
          this.fileUrl = await this.encodeImage(this.files[this.selected]);
        } else if (files[this.selected].type == "video/mp4") {
          const video: Vue | Element | Vue[] | Element[] = this.$refs.videomp4;
          this.setVideoObject(video as Element, this.files[this.selected]);
        } else if (files[this.selected].type == "video/quicktime") {
          const video: Vue | Element | Vue[] | Element[] = this.$refs.videomov;
          this.setVideoObject(video as Element, this.files[this.selected]);
        } else if (files[this.selected].type == "application/pdf") {
          this.fileUrl = this.convertObjectUrl(this.files[this.selected]);
        }
      }
    });

    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  /**
   * ### video要素に指定されたvideoを設定する
   */
  public setVideoObject(video: Element, file: any): void {
    if (video instanceof Element) {
      video.addEventListener(
        "canplay",
        () => {
          this.canPlay = true;
        },
        false
      );
      this.canPlay = false;
      this.fileUrl = "";
      this.fileUrl = this.convertObjectUrl(file);
    }

    return;
  }

  /**
   * ファイルをBase64エンコードする
   *
   * @param file ファイル
   */
  public async encodeImage(file: File): Promise<string> {
    const fileUrl: string = await FileReaderWrapper.readAsDataURL(file);

    return fileUrl;
  }

  /**
   * ファイルからObjectを作る
   *
   * @param file ファイル
   */
  public convertObjectUrl(file: File): string {
    const fileUrl: string = window.URL.createObjectURL(file);

    return fileUrl;
  }

  /**
   * モーダルの非表示
   */
  public hide() {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.hide();
    }

    return;
  }

  /**
   * 画像表示ボタン押下イベント
   */
  public async selectImage(index: number) {
    this.selected = index;
    // ローディングを出せるように見直しすべき
    if (this.files && this.files[this.selected]) {
      if (this.files[this.selected].type == "image/jpeg" || this.files[this.selected].type == "image/png") {
        this.fileUrl = await this.encodeImage(this.files[this.selected]);
      } else if (this.files[this.selected].type == "video/mp4") {
        const video: Vue | Element | Vue[] | Element[] = this.$refs.videomp4;
        this.setVideoObject(video as Element, this.files[this.selected]);
      } else if (this.files[this.selected].type == "video/quicktime") {
        const video: Vue | Element | Vue[] | Element[] = this.$refs.videomov;
        this.setVideoObject(video as Element, this.files[this.selected]);
      } else if (this.files[this.selected].type == "application/pdf") {
        this.fileUrl = this.convertObjectUrl(this.files[this.selected]);
      }
    }

    return;
  }
}
</script>
<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.pdf {
  width: 100%;
  height: 83vh;
}

.trash {
  color: $font-base-color;
  font-size: 16px;
}
</style>
